/**
 * 本地缓存 OpenIM user token（与 Nexora JWT 分离）。
 * 退出登录时必须一并清掉，防止串号。
 */

const IM_BOOTSTRAP_KEY = "im.bootstrap.v1";

import type { ImBootstrap } from "../types";

/** 持久化 bootstrap（start() 成功后调用，刷新页面可复用）。 */
export function saveImBootstrap(data: ImBootstrap): void {
  localStorage.setItem(IM_BOOTSTRAP_KEY, JSON.stringify(data));
}

/** 读取缓存的 bootstrap；不存在或 JSON 损坏时返回 null（不抛错）。 */
export function loadImBootstrap(): ImBootstrap | null {
  try {
    const raw = localStorage.getItem(IM_BOOTSTRAP_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ImBootstrap;
  } catch {
    return null;
  }
}

/** 清除缓存（stop()/退出登录时必须调用，防止换账号串号）。 */
export function clearImBootstrap(): void {
  try {
    localStorage.removeItem(IM_BOOTSTRAP_KEY);
  } catch {
    /* ignore */
  }
}